import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import * as notification from "../notifications";
import { fetchError, fetchRequest, fetchSuccess } from "./actions";
import { FailedUploadActionTypes } from "./types";
import { executeRestCallWithJsonAnswer, IJsonAnswer } from "../../utils/remoteUtils";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    var token: string = yield select((state) => state.authentication.token);
    const request = action.payload;
    var url = `api/faileduploads?pageSize=${request.pageSize}&page=${request.page}`;
    if (request.instituteId > 0) {
      url += `&filterInstitute=${request.instituteId}`;
    }
    const res: IJsonAnswer = yield call(executeRestCallWithJsonAnswer, "get", url, token);
    if (res.error) {
      yield put(notification.restResultErrorNotification(res.statusCode, notification.fetchErrorNotification()));
      yield put(fetchError(res.error));
    } else {
      yield put(fetchSuccess(res.data));
    }
  } catch (err) {
    yield put(notification.fetchErrorNotification());
    if (err instanceof Error) {
      yield put(fetchError(err.stack!));
    } else {
      yield put(fetchError("An unknown error occured."));
    }
  }
}

function* watchRequests() {
  yield takeEvery(FailedUploadActionTypes.FETCH_REQUEST, handleFetch);
}

export function* failedUploadSaga() {
  yield all([fork(watchRequests)]);
}
